const state = {
    routes: [
        // REL
        {path: '/products', name: 'Умный Дом', subs: true},
        {path: '/decisions', name: 'Решения'},
        // {path: '/services', name: 'Решения'},
        // {path: '/cases', name: 'Наши кейсы'},
        // {path: '/support', name: 'Поддержка'},
        {path: '/contacts', name: 'Контакты'}
    ],
}

export default {
    state
}


// WEBPACK FOOTER //
// ./src/store/modules/menu/menu.js